import Vidim from 'vidim';
import helpers from './helpers.js';

/*
===================================================================
Video Backgrounds on masthead
===================================================================
*/
export default (function () {
  return {
    init() {
      let bgVideo;
      const vidMastheads = document.querySelectorAll('.masthead__bg[data-yt-id], .masthead__bg[data-mp4]');
      if (vidMastheads.length === 0) return;

      helpers.forEach(vidMastheads, (i, el) => {
        const poster = el.getAttribute('data-poster');

        el.insertAdjacentHTML('beforeend', '<div class="masthead__video-container"></div>');
        const bg = el.querySelector('.masthead__video-container');

        if (el.getAttribute('data-yt-id') !== null) {
          bgVideo = new Vidim(bg, {
            type: 'YouTube',
            src: el.getAttribute('data-yt-id'),
            poster,
            autoplay: true,
            loop: true,
            muted: true,
            overlayClass: 'masthead__mask',
            showPosterBeforePlay: true,
          });
        } else if (el.getAttribute('data-mp4')) {
          bgVideo = new Vidim(bg, {
            src: [
              {
                type: 'video/mp4',
                src: el.getAttribute('data-mp4'),
              },
            ],
            poster,
            autoplay: true,
            loop: true,
            muted: true,
            overlayClass: 'masthead__mask',
            showPosterBeforePlay: true,
          });
        }
        bgVideo.addEventListener('play', (e) => {
          helpers.addClass(el, 'is-playing');
        });
      });
    },
  };
})();
